import { Partner } from '@/types/partners';
import { Box, Text, VStack } from '@chakra-ui/react';

interface PartnerSearchResultsProps {
  partners: Partner[];
  searchQuery: string;
  onPartnerSelect?: (partner: Partner) => void;
  maxHeight?: string;
}

export const PartnerSearchResults = ({
  partners = [],
  searchQuery,
  onPartnerSelect,
  maxHeight = '300px',
}: PartnerSearchResultsProps) => {
  const hasPartners = partners.length > 0;

  if (hasPartners) {
    return (
      <VStack gap={0} align="stretch" maxHeight={maxHeight} overflowY="auto">
        <Box px={3} py={1.5} bg="gray.50">
          <Text fontSize="xs" fontWeight="semibold" color="gray.600" textTransform="uppercase">
            Partners
          </Text>
        </Box>
        {partners.map(partner => (
          <Box
            key={partner.id}
            p={3}
            cursor="pointer"
            _hover={{ bg: 'gray.50' }}
            onClick={() => onPartnerSelect?.(partner)}
            borderBottom="1px solid"
            borderColor="gray.100"
            _last={{ borderBottom: 'none' }}
          >
            <VStack gap={1} align="start">
              <Text fontSize="sm" fontWeight="medium">
                {partner.name}
              </Text>
              <Text fontSize="xs" color="gray.500">
                ID: {partner.id}
              </Text>
            </VStack>
          </Box>
        ))}
      </VStack>
    );
  }

  if (searchQuery.length > 0) {
    return (
      <Box p={3}>
        <Text fontSize="sm" color="gray.500">
          No partners found
        </Text>
      </Box>
    );
  }

  return null;
};
